/* ============================================================
   YOLÈTE — Enrichissement du catalogue (couche runtime)
   ------------------------------------------------------------
   Chargé APRÈS data.js, AVANT common.js, sur toutes les pages.
   Ne modifie PAS data.js (qui reste régénérable via import_shopify.py).
   Rôle :
     1. Injecte les photos HD de boucles (dossier client) en image
        principale + galerie.
     2. Dérive, pour chaque boucle, des attributs "bijou" utilisés
        par les filtres et les collections de la boutique :
          p.finishes    -> ['dore','argent','vieil-or','vieil-argent']
          p.collections -> ['intemporelle','bijou','western',
                            'jungle','glitter','emaillee','statement','black-list']
          p.isNew       -> boucle de la nouvelle campagne photo
   ============================================================ */

/* Photos HD fournies par la maison (redimensionnées web, fond blanc). */
const HD_BOUCLE_IMAGES = {
  "boucle-n01": ["https://cdn.shopify.com/s/files/1/0790/8714/1213/files/boucles__n01.jpg"],
  "copie-de-boucle-n102": ["https://cdn.shopify.com/s/files/1/0790/8714/1213/files/boucles__n103.jpg"],
  "boucle-n12-25": ["https://cdn.shopify.com/s/files/1/0790/8714/1213/files/boucles__n12-25.jpg"],
  "boucle-n12": ["https://cdn.shopify.com/s/files/1/0790/8714/1213/files/boucles__n12.jpg"],
  "boucle-n133": [],
  "boucle-n14-25": ["https://cdn.shopify.com/s/files/1/0790/8714/1213/files/boucles__n14-25.jpg"],
  "boucle-n14": ["https://cdn.shopify.com/s/files/1/0790/8714/1213/files/boucles__n14.jpg"],
  "boucle-n18": ["https://cdn.shopify.com/s/files/1/0790/8714/1213/files/boucles__n18.jpg"],
  "boucle-n18-1": ["https://cdn.shopify.com/s/files/1/0790/8714/1213/files/boucles__n183.jpg"],
  "boucle-n19-25": ["https://cdn.shopify.com/s/files/1/0790/8714/1213/files/boucles__n19-25.jpg"],
  "boucle-n19": ["https://cdn.shopify.com/s/files/1/0790/8714/1213/files/boucles__n19.jpg"],
  "boucle-n20-25": ["https://cdn.shopify.com/s/files/1/0790/8714/1213/files/boucles__n20-25.jpg"],
  "boucle-n20": ["https://cdn.shopify.com/s/files/1/0790/8714/1213/files/boucles__n20.jpg"],
  "boucle-n205": ["https://cdn.shopify.com/s/files/1/0790/8714/1213/files/boucles__n205.jpg"],
  "boucle-n21-copy": ["https://cdn.shopify.com/s/files/1/0790/8714/1213/files/boucles__n21-25.jpg"],
  "boucle-n21": ["https://cdn.shopify.com/s/files/1/0790/8714/1213/files/boucles__n21.jpg"],
  "boucle-n213": ["https://cdn.shopify.com/s/files/1/0790/8714/1213/files/boucles__n214.jpg"],
  "boucle-n222": ["https://cdn.shopify.com/s/files/1/0790/8714/1213/files/boucles__n222.jpg"],
  "boucle-n247": ["https://cdn.shopify.com/s/files/1/0790/8714/1213/files/boucles__n247.jpg"],
  "boucle-n239": ["https://cdn.shopify.com/s/files/1/0790/8714/1213/files/boucles__n248.jpg"],
  "boucle-n256": ["https://cdn.shopify.com/s/files/1/0790/8714/1213/files/boucles__n256.jpg"],
  "boucle-n239-copie": ["https://cdn.shopify.com/s/files/1/0790/8714/1213/files/boucles__n266-25.jpg"],
  "boucle-n269": ["https://cdn.shopify.com/s/files/1/0790/8714/1213/files/boucles__n269.jpg"],
  "boucle-n27": ["https://cdn.shopify.com/s/files/1/0790/8714/1213/files/boucles__n27.jpg"],
  "boucle-n271-1": ["https://cdn.shopify.com/s/files/1/0790/8714/1213/files/boucles__n271.jpg"],
  "boucle-n273": ["https://cdn.shopify.com/s/files/1/0790/8714/1213/files/boucles__n273.jpg"],
  "boucle-n271": ["https://cdn.shopify.com/s/files/1/0790/8714/1213/files/boucles__n281.jpg"],
  "boucle-n29": ["https://cdn.shopify.com/s/files/1/0790/8714/1213/files/boucles__n29.jpg"],
  "boucle-n290": ["https://cdn.shopify.com/s/files/1/0790/8714/1213/files/boucles__n290-bm.jpg", "https://cdn.shopify.com/s/files/1/0790/8714/1213/files/boucles__n290-acajou.jpg"],
  "boucle-n30": ["https://cdn.shopify.com/s/files/1/0790/8714/1213/files/boucles__n30.jpg"],
  "boucle-n303": ["https://cdn.shopify.com/s/files/1/0790/8714/1213/files/boucles__n303.jpg"],
  "boucle-n305": ["https://cdn.shopify.com/s/files/1/0790/8714/1213/files/boucles__n305.jpg"],
  "boucle-n306": ["https://cdn.shopify.com/s/files/1/0790/8714/1213/files/boucles__n306.jpg"],
  "boucle-n308": ["https://cdn.shopify.com/s/files/1/0790/8714/1213/files/boucles__n308.jpg"],
  "boucle-n309": ["https://cdn.shopify.com/s/files/1/0790/8714/1213/files/boucles__n309.jpg"],
  "boucle-n211-1": ["https://cdn.shopify.com/s/files/1/0790/8714/1213/files/boucles__n311.jpg"],
  "boucle-n312": ["https://cdn.shopify.com/s/files/1/0790/8714/1213/files/boucles__n312.jpg"],
  "boucle-n314-25": [],
  "boucle-n314-1": [],
  "boucle-n314": [],
  "boucle-n335": [],
  "boucle-n319": ["https://cdn.shopify.com/s/files/1/0790/8714/1213/files/boucles__n319.jpg"],
  "boucle-n320": ["https://cdn.shopify.com/s/files/1/0790/8714/1213/files/boucles__n320.jpg"],
  "boucle-n321": ["https://cdn.shopify.com/s/files/1/0790/8714/1213/files/boucles__n321-25.jpg"],
  "boucle-n325-1": ["https://cdn.shopify.com/s/files/1/0790/8714/1213/files/boucles__n325.jpg"],
  "boucle-n336": ["https://cdn.shopify.com/s/files/1/0790/8714/1213/files/boucles__n326.jpg"],
  "boucle-n327": ["https://cdn.shopify.com/s/files/1/0790/8714/1213/files/boucles__n327.jpg"],
  "boucle-n330": ["https://cdn.shopify.com/s/files/1/0790/8714/1213/files/boucles__n330.jpg"],
  "boucle-n331": ["https://cdn.shopify.com/s/files/1/0790/8714/1213/files/boucles__n331g.jpg", "https://cdn.shopify.com/s/files/1/0790/8714/1213/files/boucles__n331s.jpg"],
  "boucle-n332": ["https://cdn.shopify.com/s/files/1/0790/8714/1213/files/boucles__n332.jpg"],
  "boucle-n333": ["https://cdn.shopify.com/s/files/1/0790/8714/1213/files/boucles__n333.jpg"],
  "boucle-n334-1": ["https://cdn.shopify.com/s/files/1/0790/8714/1213/files/boucles__n334.jpg"],
  "boucle-n335-1": ["https://cdn.shopify.com/s/files/1/0790/8714/1213/files/boucles__n335.jpg"],
  "boucle-n336-1": ["https://cdn.shopify.com/s/files/1/0790/8714/1213/files/boucles__n336g.jpg", "https://cdn.shopify.com/s/files/1/0790/8714/1213/files/boucles__n336s.jpg"],
  "boucle-n379": ["https://cdn.shopify.com/s/files/1/0790/8714/1213/files/boucles__n338.jpg"],
  "boucle-n339": ["https://cdn.shopify.com/s/files/1/0790/8714/1213/files/boucles__n339-black.jpg", "https://cdn.shopify.com/s/files/1/0790/8714/1213/files/boucles__n339-acajou.jpg", "https://cdn.shopify.com/s/files/1/0790/8714/1213/files/boucles__n339-ivoire.jpg"],
  "boucle-n341": ["https://cdn.shopify.com/s/files/1/0790/8714/1213/files/boucles__n341.jpg"],
  "boucle-n343-25": ["https://cdn.shopify.com/s/files/1/0790/8714/1213/files/boucles__n343-25.jpg"],
  "boucle-n343": ["https://cdn.shopify.com/s/files/1/0790/8714/1213/files/boucles__n343-gold.jpg", "https://cdn.shopify.com/s/files/1/0790/8714/1213/files/boucles__n343-silver.jpg"],
  "boucle-n345": ["https://cdn.shopify.com/s/files/1/0790/8714/1213/files/boucles__n345.jpg"],
  "boucle-n230": ["https://cdn.shopify.com/s/files/1/0790/8714/1213/files/boucles__n348.jpg"],
  "boucle-n228": ["https://cdn.shopify.com/s/files/1/0790/8714/1213/files/boucles__n348.jpg"],
  "boucle-n232": ["https://cdn.shopify.com/s/files/1/0790/8714/1213/files/boucles__n348.jpg"],
  "boucle-n231": ["https://cdn.shopify.com/s/files/1/0790/8714/1213/files/boucles__n348.jpg"],
  "boucle-n226": ["https://cdn.shopify.com/s/files/1/0790/8714/1213/files/boucles__n348.jpg"],
  "boucle-n224": ["https://cdn.shopify.com/s/files/1/0790/8714/1213/files/boucles__n349-25.jpg"],
  "boucle-n225": ["https://cdn.shopify.com/s/files/1/0790/8714/1213/files/boucles__n349-25.jpg"],
  "boucle-n354-25": ["https://cdn.shopify.com/s/files/1/0790/8714/1213/files/boucles__n354-25.jpg"],
  "boucle-n354": ["https://cdn.shopify.com/s/files/1/0790/8714/1213/files/boucles__n354.jpg"],
  "boucle-n361-25": ["https://cdn.shopify.com/s/files/1/0790/8714/1213/files/boucles__n361-25.jpg"],
  "boucle-n372": ["https://cdn.shopify.com/s/files/1/0790/8714/1213/files/boucles__n372.jpg"],
  "boucle-n378-25": ["https://cdn.shopify.com/s/files/1/0790/8714/1213/files/boucles__n378-25.jpg"],
  "boucle-n380": ["https://cdn.shopify.com/s/files/1/0790/8714/1213/files/boucles__n380.jpg"],
  "boucle-n381": ["https://cdn.shopify.com/s/files/1/0790/8714/1213/files/boucles__n381.jpg"],
  "boucle-n42-25": ["https://cdn.shopify.com/s/files/1/0790/8714/1213/files/boucles__n42-25.jpg"],
  "boucle-n50-25": ["https://cdn.shopify.com/s/files/1/0790/8714/1213/files/boucles__n50-25.jpg"],
  "boucle-n50": ["https://cdn.shopify.com/s/files/1/0790/8714/1213/files/boucles__n50.jpg"],
  "boucle-n54-1": ["https://cdn.shopify.com/s/files/1/0790/8714/1213/files/boucles__n54.jpg"],
  "boucle-n54": ["https://cdn.shopify.com/s/files/1/0790/8714/1213/files/boucles__n54.jpg"],
};

/* Finitions (métal) nommées par un libellé de pastille ou une option Shopify.
   « Or », « Doré », « Gold / Cocoa », « Valentine or » -> doré ; « Antic silver »
   -> vieil argent ; « Coloris », « Noir », « Topaze » -> aucune, on laisse alors
   parler la description. Partagé avec produits.js, qui s'en sert pour montrer la
   bonne photo quand un filtre de finition est actif. */
function finitionsDeLibelle(txt) {
  const t = String(txt || '').toUpperCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  const f = [];
  if (/VIEIL OR|ANTIC.?GOLD|ANTIQUE GOLD|OLD GOLD/.test(t)) f.push('vieil-or', 'dore');
  if (/VIEIL ARGENT|ANTIC.?SILVER|ANTIQUE SILVER|OLD SILVER/.test(t)) f.push('vieil-argent', 'argent');
  if (/\bOR\b|DORE|\bGOLD\b|LAITON|\bORO\b/.test(t)) f.push('dore');
  if (/ARGENT|\bSILVER\b/.test(t)) f.push('argent');
  return [...new Set(f)];
}
window.finitionsDeLibelle = finitionsDeLibelle;

/* Finitions d'une boucle d'après ses pastilles. Rend null quand aucune pastille
   ne nomme de métal, pour que l'appelant garde l'ancienne règle. */
function finitionsDesPastilles(p) {
  const sw = (typeof BOUCLE_SWATCHES !== 'undefined') ? BOUCLE_SWATCHES[p.id] : null;
  /* Boucle sans entrée dans boucles-photos.js : finitions lues dans ses variantes Shopify. */
  const list = (sw && sw.swatches) || ((typeof swatchesShopify === 'function') ? (swatchesShopify(p) || {}).swatches : null);
  if (!list || !list.length) return null;
  const f = [];
  for (const s of list) f.push(...finitionsDeLibelle((s.label || '') + ' ' + (s.voption || '')));
  return f.length ? [...new Set(f)] : null;
}

/* Les fichiers de pastilles (swatches.js, boucles-photos.js) sont chargés APRÈS
   ce fichier, et leur ordre ne peut pas être inversé sans changer quelle photo
   HD gagne sur les cartes. Les finitions sont donc recalculées à la demande par
   les pages qui s'en servent, une fois les pastilles là. */
window.recalculerFinitions = function () {
  if (typeof PRODUCTS === 'undefined') return 0;
  var n = 0;
  PRODUCTS.forEach(function (p) {
    if (p.type !== 'boucle') return;
    var f = finitionsDesPastilles(p);
    if (!f) return;
    var avant = (p.finishes || []).join('+');
    p.finishes = f;
    var coul = (p.couleur || []).filter(function (c) { return c !== 'or' && c !== 'argent'; });
    if (f.indexOf('dore') !== -1) coul.unshift('or');
    if (f.indexOf('argent') !== -1) coul.push('argent');
    p.couleur = coul.filter(function (c, i) { return coul.indexOf(c) === i; });
    if (avant !== f.join('+')) n++;
  });
  return n;
};

(function enrichCatalog() {
  if (typeof PRODUCTS === 'undefined') return;

  /* Les ensembles « tige + boucle » (Look Mexique, Preto/Python/Suède avec boucle)
     ne sont pas commercialisés sur le site : la maison vend la boucle et la tige
     séparément. On les retire du catalogue. */
  for (let i = PRODUCTS.length - 1; i >= 0; i--) {
    if (PRODUCTS[i].type === 'ceinture') PRODUCTS.splice(i, 1);
  }

  const COLLECTION_LABELS = {
    intemporelle: 'Intemporelles',
    bijou: 'Bijou',
    western: 'Western',
    jungle: 'Animalier',
    glitter: 'Glitter',
    emaillee: 'Émaillées',
    statement: 'Statement',
    'black-list': 'Black List',
  };
  const FINISH_LABELS = {
    dore: 'Doré',
    argent: 'Argenté',
    'vieil-or': 'Vieil or',
    'vieil-argent': 'Vieil argent',
  };
  const COULEUR_LABELS = {
    or: 'Or', argent: 'Argent', ivoire: 'Ivoire', noir: 'Noir', marron: 'Marron',
  };
  /* Libellé choisi dans le champ Shopify « Collection de la boucle » -> collection du site */
  const SLUG_DE_LIBELLE = {};
  Object.keys(COLLECTION_LABELS).forEach(k => { SLUG_DE_LIBELLE[COLLECTION_LABELS[k]] = k; });
  /* exposés pour la boutique */
  window.COLLECTION_LABELS = COLLECTION_LABELS;
  window.FINISH_LABELS = FINISH_LABELS;
  window.COULEUR_LABELS = COULEUR_LABELS;

  /* Best-sellers : sur la boutique, la collection Shopify « Best-sellers », remplie chaque
     mois avec les 12 boucles les plus vendues le mois précédent (scripts/best_sellers.py,
     21/10/2026). La sélection éditoriale ci-dessous ne sert qu'à la copie de travail. */
  const BESTSELLERS = (typeof window !== 'undefined' && window.SHOP) ? new Set(window.SHOP.bestsellers || []) : new Set([
    'boucle-n01', 'copie-de-boucle-n102', 'boucle-n354', 'boucle-n133', 'boucle-n339',
    'boucle-n331', 'boucle-n290', 'boucle-n12', 'boucle-n14', 'boucle-n27',
    'boucle-n303', 'boucle-n319']);

  /* Corrections manuelles de collection (le tag auto par mots-clés se trompe parfois).
     Code de base -> liste EXCLUSIVE de collections. Vérifié dans les books.
     N349 : coloris GOLD/GLITTER dans le book -> Glitter (et non Voglio Bene/Émaillée). */
  const COLLECTION_OVERRIDES = { 'N349': ['glitter'] };

  /* Boucles saisies depuis le book, en attendant leur création dans Shopify.
     N328 et N370 étaient affichées « Bientôt » faute de prix connu. Prix relevés
     dans « Books 2026/BOOK ANNUEL 26_27.pdf », planche Les Permanents (N328 réf
     0041 SILVER/GOLD 39.00€, N370 réf 0031 SILVER et OLD GOLD 39.00€).
     Le test sur l'id les fait disparaître d'ici toutes seules le jour où elles
     existent dans Shopify, donc pas de doublon après régénération de data.js.
     Injectées AVANT la boucle d'enrichissement pour hériter finitions et collections. */
  const BOOK_NOUVEAUTES = [
    { code: 'N328', price: 39.0, finition: 'SILVER/GOLD' },
    { code: 'N370', price: 39.0, finition: 'SILVER, OLD GOLD' }];
  /* Sur la boutique Shopify (window.SHOP, posé par data-shopify.js), le catalogue fait
     foi : une boucle absente de SHOP est en brouillon ou retirée de la vente. L'injecter
     ici en ferait une fiche fantôme, visible mais sans variante, donc impossible à
     acheter. C'est ce qui montrait la N364/25 et la N366/25 (23/09/2026). La copie de
     travail, sans SHOP, garde l'injection. */
  const SUR_SHOPIFY = typeof window !== 'undefined' && !!window.SHOP;
  for (const n of BOOK_NOUVEAUTES) {
    if (SUR_SHOPIFY) break;
    const id = 'boucle-' + n.code.toLowerCase();
    if (PRODUCTS.some(p => p.id === id)) continue;
    const photo = 'https://cdn.shopify.com/s/files/1/0790/8714/1213/files/boucles-site__' + id + '-gold.jpg?v=19';   /* photos studio du Drive, septembre 2026 */
    PRODUCTS.push({
      id: id, name: 'BOUCLE ' + n.code, type: 'boucle', width: 40,
      style: 'Intemporelle', audience: 'femme', price: n.price,
      img: photo, images: [photo], colors: [],
      descr: 'BOUCLE INTERCHANGEABLE COLLECTION INTEMPORELLE de la marque Yolète, '
           + "cette boucle s'adapte sur TOUS NOS CUIRS en 40mm. Finition " + n.finition + '.',
    });
  }
  /* Codes désormais vendus, à retirer du bloc « Bientôt » (filtré dans common.js). */
  window.SORTIS_DU_COMING_SOON = BOOK_NOUVEAUTES.map(n => n.code);


  /* ---- Fichier maison « Dimensions boucles et prix de vente » (28/08/2026) ----
     Source de vérité pour le PRIX et les DIMENSIONS. Clef CODE|largeur.
     Corrige au chargement les écarts avec l'export Shopify, et alimente la
     ligne « Dimensions » de la fiche produit. */
  const MAISON_TARIF = {
    'N183|40':[100,55,67.00], 'N319|40':[55,60,39.90], 'N269|40':[70,70,35.00],
    'N327|40':[85,65,29.00], 'N305|40':[85,80,39.00], 'N01|40':[70,70,49.00],
    'N256|40':[50,50,59.00], 'N372|40':[85,65,35.00], 'N354|40':[70,55,59.00],
    'N306|40':[70,65,49.00], 'N312|40':[90,75,79.00], 'N320|40':[100,60,35.00],
    'N12|40':[85,65,39.50], 'N103|40':[85,70,49.00], 'N273|40':[60,70,29.00],
    'N30|40':[100,75,59.00], 'N309|40':[80,50,29.00], 'N335|40':[75,75,89.00],
    'N370|40':[125,60,39.00], 'N308|40':[105,65,39.50], 'N248|40':[65,60,53.00],
    'N281|40':[65,60,49.50], 'N381|40':[75,60,49.50], 'N27|40':[95,60,59.50],
    'N331|40':[125,50,45.00], 'N343|40':[70,60,75.00], 'N21|40':[80,55,49.90],
    'N303|40':[70,55,65.00], 'N380|40':[65,70,55.00], 'N19|40':[100,60,55.00],
    'N50|40':[85,65,55.00], 'N205|40':[90,60,59.00], 'N20|40':[70,55,59.90],
    'N14|40':[100,55,57.00], 'N247|40':[110,55,59.00], 'N311|40':[80,75,55.00],
    'N328|40':[90,65,39.00], 'N332|40':[80,55,35.00], 'N338|40':[90,75,99.50],
    'N214|40':[65,65,95.00], 'N411|40':[80,60,89.00], 'N412|40':[50,75,79.90],
    'N325|40':[80,65,99.50], 'N376|40':[70,55,99.50], 'N417|40':[90,62,69.00],
    'N14|25':[65,30,39.00], 'N321|25':[35,35,15.00], 'N266|25':[55,45,39.90],
    'N366|25':[85,35,19.50], 'N20|25':[45,35,39.90], 'N15|25':[80,35,38.00],
    'N364|25':[55,35,19.50], 'N19|25':[80,45,19.50], 'N50|25':[65,50,45.00],
    'N349|25':[70,55,75.00], 'N354|25':[70,55,59.00], 'N411|25':[80,60,89.00],
    'N412|25':[50,75,79.90]
  };
  window.MAISON_TARIF = MAISON_TARIF;
  /* Passants relevés au fichier (mm), affichés en fiche quand connus. */
  window.MAISON_PASSANT = { 'N312|40':[45,16], 'N335|40':[45,10], 'N338|40':[45,20], 'N266|25':[30,5] };

  for (const p of PRODUCTS) {
    /* --- 1. Photos HD --- */
    const hd = SUR_SHOPIFY ? null : HD_BOUCLE_IMAGES[p.id];   /* boutique : photos de la fiche Shopify */
    if (hd && hd.length) {
      const rest = (p.images || []).filter(x => !hd.includes(x));
      p.img = hd[0];
      p.images = [...hd, ...rest];
      p.isNew = true;
    }
    if (BESTSELLERS.has(p.id)) p.bestseller = true;

    if (p.type !== 'boucle') continue;

    /* Prix + dimensions officiels de la maison (priment sur l'export Shopify). */
    const codeM = (boucleBase(p) || '').toUpperCase();
    const tarif = MAISON_TARIF[codeM + '|' + p.width];
    /* Dimensions saisies dans la fiche Shopify d'abord (champs Largeur et Hauteur,
       24/09/2026), celles du fichier ensuite. */
    if (p.mmShopify) p.mm = p.mmShopify.slice();
    if (tarif) {
      if (!p.mmShopify) p.mm = [tarif[0], tarif[1]];
      /* Sur la boutique, le prix Shopify fait foi : c'est lui qui est encaissé, et
         Charlotte doit pouvoir le changer sans toucher au code (24/09/2026). Les
         dimensions du fichier restent affichées, Shopify ne les porte pas. */
      if (!window.SHOP && Math.abs((p.price || 0) - tarif[2]) > 0.005) { p.priceOld = p.price; p.price = tarif[2]; }
    }

    const D = ((p.descr || '') + ' ' + (p.name || '')).toUpperCase();
    const style = p.style || '';

    /* --- 2. Finition (métal) ---
       D'abord les pastilles réellement proposées sur le site (22 sept 2026) :
       la cliente filtre sur ce qu'elle voit. La description ne suffisait pas.
       Elle disait « OLD GOLD » pour la N27, la N380 et la N321 dont seule la
       version argentée est photographiée, et elle ne nommait aucun métal sur
       60 boucles vendues en or ET en argent, qui n'apparaissaient donc dans
       aucun des deux filtres. Le texte ne sert plus que de repli, pour les
       pastilles qui ne nomment pas de métal (« Coloris », « Noir »...). */
    const fin = [];
    const parPastilles = finitionsDesPastilles(p);
    if (parPastilles) {
      fin.push(...parPastilles);
    } else {
      const vieilOr = /OLD GOLD|VIEIL OR|OR ANTIQUE|ANTIQUE GOLD|ANTIC.?GOLD/.test(D);
      const vieilArg = /VIEIL ARGENT|ARGENT ANTIQUE|ANTIQUE SILVER|OLD SILVER|ANTIC.?SILVER/.test(D);
      const gold = /\bGOLD\b|\bDOR[ÉE]E?\b|\bLAITON\b|\bORO\b|\bOR\b/.test(D);
      const silver = /\bSILVER\b|\bARGENT[ÉE]?\b/.test(D);
      if (vieilOr) fin.push('vieil-or');
      if (vieilArg) fin.push('vieil-argent');
      if (gold || vieilOr) fin.push('dore');
      if (silver || vieilArg) fin.push('argent');
    }
    p.finishes = [...new Set(fin)];

    /* --- 3. Collections (familles de style) --- */
    const coll = [];
    if (style === 'Intemporelle' || /INTEMPORELLE|VINTAGE/.test(D)) coll.push('intemporelle');
    if (style === 'Bijou') coll.push('bijou');
    if (style === 'Jungle' || /L[ÉE]OPARD|Z[ÈE]BRE|PYTHON|SERPENT|CROCO|PANTH[ÈE]RE|ANIMAL/.test(D)) coll.push('jungle');
    if (style === 'Glitter' || /GLITTER|PAILLET|STRASS/.test(D)) coll.push('glitter');
    if (style === 'Black List') coll.push('black-list');
    if (style === 'Nahua' || /CONCHO|NAVAJO|APACHE|SANTA.?FE|AIGLE|EAGLE|LONGHORN|TAUREAU|BISON|BUFFLE|TURQUOISE|WESTERN|CACTUS|NAHUA|T[ÊE]TE DE MORT/.test(D)) coll.push('western');
    if (style === 'Voglio Bene' || /[ÉE]MAIL|ENAMEL|VERNIS|VOGLIO/.test(D)) coll.push('emaillee');
    if (style === 'Bijou' || style === 'Jungle' || /SCARAB|PAPILLON|FLEUR|ROSACE|[ÉE]TOILE|C(?:OE|Œ)UR|(?:OE|Œ)IL|POISSON|LUNE|SOLEIL/.test(D)) coll.push('statement');
    p.collections = [...new Set(coll)];
    const ovr = COLLECTION_OVERRIDES[boucleBase(p)];
    if (ovr) p.collections = ovr.slice();
    /* Champ Shopify « Collection de la boucle » (custom.collection_boucle, 30/09/2026) :
       rempli, il décide seul de l'accroche en italique sous le nom et de la collection
       où la boucle apparaît. Vide, la déduction par mots-clés ci-dessus reste. */
    if (p.collShopify && SLUG_DE_LIBELLE[p.collShopify]) p.collections = [SLUG_DE_LIBELLE[p.collShopify]];

    /* --- 4. Couleur dominante --- */
    const coul = [];
    if (p.finishes.includes('dore') || p.finishes.includes('vieil-or')) coul.push('or');
    if (p.finishes.includes('argent') || p.finishes.includes('vieil-argent')) coul.push('argent');
    if (/IVOIRE|IVORY|NACRE|\bBLANC|CHAMPAGNE|CR[ÈE]ME/.test(D)) coul.push('ivoire');
    if (/\bNOIR|\bBLACK/.test(D)) coul.push('noir');
    if (/MARRON|\bBROWN|ACAJOU|COGNAC|CAMEL|FAUVE|TAUPE|WHISKY|\bMIEL/.test(D)) coul.push('marron');
    p.couleur = [...new Set(coul)];
  }
})();

/* ============================================================
   Dédoublonnage des boucles (demande client).
   Un même modèle est présent plusieurs fois dans l'export Shopify :
   N314, N314-1 (doublon), N314B (variante), N314/25 (largeur 25).
   On regroupe par CODE DE BASE + largeur et on ne garde qu'un
   représentant fusionné, afin qu'un modèle n'apparaisse qu'une
   seule fois dans la boutique et dans le configurateur.
   ============================================================ */
function boucleBase(p) {
  let n = (p.name || '').toUpperCase().trim();
  n = n.replace(/^BOUCLE\s+/, '');
  n = n.replace(/[\/\s]*\b(25|40)\s*(MM)?\b\s*$/, '');       // enlève le marqueur de largeur
  const m = n.match(/([A-Z]{1,4}\d{1,4})/);                  // N314, LUX976 (lettre de variante après les chiffres ignorée)
  if (m) return m[1];
  return (n.split(/[\s/]/)[0] || p.id).trim();
}

/* Regroupe une liste de produits boucle ; renvoie un représentant par (code, largeur). */
function dedupeBoucles(list) {
  const groups = new Map();
  for (const p of list) {
    const key = boucleBase(p) + '|' + p.width;
    if (!groups.has(key)) groups.set(key, []);
    groups.get(key).push(p);
  }
  const reps = [];
  for (const grp of groups.values()) {
    const withImg = grp.filter(p => p.img);
    const pool = withImg.length ? withImg : grp;
    const rep = { ...pool.slice().sort((a, b) => a.name.length - b.name.length)[0] };
    const uni = f => [...new Set(grp.flatMap(p => (Array.isArray(p[f]) ? p[f] : [])))];
    rep.finishes = uni('finishes');
    rep.collections = uni('collections');
    rep.couleur = uni('couleur');
    rep.isNew = grp.some(p => p.isNew);
    rep.bestseller = grp.some(p => p.bestseller);
    reps.push(rep);
  }
  return reps;
}

window.boucleBase = boucleBase;
window.dedupeBoucles = dedupeBoucles;

/* Dédoublonnage des ceintures par base (PRETO, PYTHON, SUEDE...) — les
   variantes de cuir deviennent des coloris cliquables sur une seule carte. */
const CEINTURE_COLORS = /\b(BLACK|BROWN|NAVY|NUIT|NOIR|MARRON|BLEU|BEIGE|IVOIRE|BLANC|ROUGE|VERT|GOLD|SILVER|CAMEL|COGNAC|TAUPE|WHISKY|KAKI)\b/gi;
function ceintureBase(p) {
  return (p.name || '').toUpperCase().replace(/AVEC BOUCLE/g, '').replace(CEINTURE_COLORS, '').replace(/\s+/g, ' ').trim();
}
function dedupeCeintures(list) {
  const g = new Map();
  for (const p of list) { const k = ceintureBase(p); if (!g.has(k)) g.set(k, p); }
  return [...g.values()];
}
window.ceintureBase = ceintureBase;
window.dedupeCeintures = dedupeCeintures;

/* Regroupement des TIGES par famille de cuir (demande client) : une carte par
   famille (Savane, Animal, Preto, Python, Vintage, Vintage Léopard, Suède), les
   coloris deviennent des pastilles. Les variantes restent des produits distincts. */
function tigeFamily(p) {
  if (p.familyName) return p.familyName;     /* nom de la fiche Shopify (tiges-catalog.js) */
  var n = (p.name || '').replace(/^Tige\s+/i, '').trim();
  if (/^Savane/i.test(n)) return 'Savane';
  if (/^Animal/i.test(n)) return 'Animal';
  if (/^Vintage\s+L[ée]opard/i.test(n)) return 'Vintage Léopard';
  if (/^Vintage/i.test(n)) return 'Vintage';
  return (n.split(/\s+/)[0] || p.id);        // Preto, Python, Suède…
}
function dedupeTiges(list) {
  var groups = new Map();
  for (var i = 0; i < list.length; i++) {
    var p = list[i], key = tigeFamily(p) + '|' + p.width;
    if (!groups.has(key)) groups.set(key, []);
    groups.get(key).push(p);
  }
  var reps = [];
  groups.forEach(function (grp) {
    /* coloris dans l'ordre de la maison (noir, marron, camel, havane, puis les autres) */
    grp.sort(function (a, b) {
      var oa = a.colorOrder != null ? a.colorOrder : 50, ob = b.colorOrder != null ? b.colorOrder : 50;
      return oa - ob || a.name.localeCompare(b.name, 'fr');
    });
    var fam = tigeFamily(grp[0]);
    var rep = Object.assign({}, grp[0]);
    rep.name = 'Tige ' + fam;                  // la carte affiche la famille
    rep.familyName = fam;
    rep.available = grp.some(function (v) { return v.available !== false; });
    rep.variants = grp.map(function (v) {
      return { id: v.id, name: v.name, label: v.colorLabel || v.name.replace(/^Tige\s+/i, ''), img: v.img, price: v.price, dotColor: v.dotColor || null };
    });
    reps.push(rep);
  });
  return reps;
}
window.tigeFamily = tigeFamily;
window.dedupeTiges = dedupeTiges;

/* Filtre "boucles réellement en dossier" (demande de l'oncle) : on n'affiche
   que les boucles dont le code est présent dans le dossier photos. */
window.inFolderBoucle = function (p) {
  if (p.type !== 'boucle') return true;
  /* Sur la boutique Shopify, Shopify décide seul (24/09/2026, demande de Nathan, pour
     que Charlotte ajoute une boucle sans passer par le code). Une boucle ACTIVE,
     publiée sur la Boutique en ligne et rangée dans une collection Book 2026 s'affiche,
     un brouillon non. Les listes fixes ci-dessous ne servent plus qu'à la copie de
     travail. Vérifié avant le retrait : les 55 boucles alors visibles figuraient toutes
     dans le fichier « Dimensions », les 7 autres fiches des collections Book étaient
     des brouillons, donc rien de nouveau n'est apparu. */
  if (window.SHOP) return true;
  const c = (boucleBase(p) || '').toUpperCase();
  /* La maison resserre le catalogue sur ses classiques : les permanents du
     Book Annuel, plus tout ce qui est classé Intemporelle ou Bijou. Le Book
     Annuel est filtré par largeur, une référence n'apparaissant en 25 mm que
     si le book la propose dans cette largeur. */
  /* Le fichier « Dimensions boucles et prix de vente » est la liste EXCLUSIVE
     des boucles vendues (décision de la maison, 3 septembre 2026). Une
     référence absente du fichier n'est pas vendue, quel que soit son book. */
  if (typeof DIM_BOUCLES_40 !== 'undefined' && typeof DIM_BOUCLES_25 !== 'undefined') {
    const ref = p.width === 25 ? DIM_BOUCLES_25 : DIM_BOUCLES_40;
    return ref.indexOf(c) !== -1;
  }
  /* Filtrage par largeur si les listes _40 / _25 existent (dossier « Site internet produits »). */
  if (p.width === 40 && typeof FOLDER_BOUCLES_40 !== 'undefined') return FOLDER_BOUCLES_40.indexOf(c) !== -1;
  if (p.width === 25 && typeof FOLDER_BOUCLES_25 !== 'undefined') return FOLDER_BOUCLES_25.indexOf(c) !== -1;
  if (typeof FOLDER_BOUCLES === 'undefined' || !FOLDER_BOUCLES.length) return true;
  return FOLDER_BOUCLES.indexOf(c) !== -1;
};

/* ---------- Prix : le fichier « Dimensions et prix de vente » fait foi ----------
   Demande de la maison du 4 septembre 2026. Seule la N18 diffère de Shopify
   (49 € au lieu de 55 €). ATTENTION : le prix Shopify doit être aligné aussi,
   sinon le panier afficherait 49 € et la caisse encaisserait 55 €.
   Copie de travail seulement : sur la boutique, ce bloc affichait la N19/25 à
   19,50 € alors que Shopify la vend 45 € (21/10/2026). Le prix Shopify fait foi,
   et data-shopify.js le verrouille. */
(function () {
  if (window.SHOP) return;
  if (typeof PRODUCTS === 'undefined' || typeof DIM_PRIX === 'undefined' || typeof boucleBase !== 'function') return;
  PRODUCTS.forEach(function (p) {
    if (p.type !== 'boucle') return;
    var ref = DIM_PRIX[(boucleBase(p) || '').toUpperCase() + '/' + p.width];
    if (ref && Math.abs(parseFloat(ref) - p.price) > 0.001) p.price = parseFloat(ref);
  });
})();
